import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.SupplierSignUp.components.FormSubmitted.title',
    defaultMessage: 'You’re off to a great start!',
  },
  subtitle: {
    id: 'containers.SupplierSignUp.components.FormSubmitted.subtitle',
    defaultMessage: 'We need you to confirm your e-mail address before continuing setting up your profile. You know, usual security measures.',
  },
  ctaTitle: {
    id: 'containers.SupplierSignUp.components.FormSubmitted.callToAction.title',
    defaultMessage: 'You’ve got mail',
  },
  ctaSubtitle: {
    id: 'containers.SupplierSignUp.components.FormSubmitted.callToAction.subtitle',
    defaultMessage: 'Open your e-mail manually or by clicking on your e-mail provider.',
  },
  ctaHint: {
    id: 'containers.SupplierSignUp.components.FormSubmitted.callToAction.hint',
    defaultMessage: 'If you still haven’t received an e-mail after a couple of minutes, please check your spam folder.',
  },
  inaccessibleTitle: {
    id: 'containers.SupplierSignUp.components.FormSubmitted.inaccessible.title',
    defaultMessage: 'Hold up, something\'s missing.',
  },
  inaccessibleSubtitle: {
    id: 'containers.SupplierSignUp.components.FormSubmitted.inaccessible.subtitle',
    defaultMessage: 'Did you confirm your e-mail address?',
  },
  inaccessibleBody: {
    id: 'containers.SupplierSignUp.components.FormSubmitted.inaccessible.body',
    defaultMessage: 'If you are looking to join VoiceArchive, go to {link} to apply. We can\'t wait to hear from you!',
  },
  inaccessibleLinkLabel: {
    id: 'containers.SupplierSignUp.components.FormSubmitted.inaccessible.linkLabel',
    defaultMessage: 'here',
  },
})
